<div class="container" [ngStyle]="{'background-color': transformedColor}">
    <p class="content">{{layoutNote.message}}</p>
</div>
